import type {FileService} from '../file/file.service';

export default class RepositoryService {
    public static serviceName = 'repositoryService';

    private imageDataMemory = {};

    /*@ngInject*/
    constructor(private fileService: FileService) {
    }

    public addFileToMemory(file, memoryName: string) {
        if (file.image) {
            this.imageDataMemory[memoryName] = new Image();
            this.imageDataMemory[memoryName].src = file.url;
        }
    }

    public getFileById(id: number) {
        return this.fileService.getFileById(id);
    }

    public getFilesByDirectory(directoryId: number) {
        return this.fileService.getFilesByDirectory(directoryId);
    }
}
